import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const [scroll, setScroll] = useState(false);

  const handleArrow = () => {};

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      const offset = 100; // Adjust for header height or other offsets
      const sectionPosition = section.offsetTop - offset;
      window.scrollTo({
        top: sectionPosition,
        behavior: "instant",
      });
    }
  };

  return (
    <footer>
      <div className="top_footer" id="contact">
        <Container>
          <Row>
            <Col lg={4} md={6} Col={12}>
              <div className="abt_side">
                <div className="logo">
                  {" "}
                  <Link to="/">
                    {" "}
                    <img
                      src={require("../images/logo-update.svg").default}
                      alt="image"
                    />
                  </Link>
                </div>
                <ul>
                  <li>
                    <Link to="#">
                      Leave Your Tasks To Us,
                      <br /> Effective Time-Saving Solutions!
                    </Link>
                  </li>
                </ul>
                <ul className="social_media">
                  <li>
                    <Link to="#" target="_blank">
                      <i className="fa-brands fa-x-twitter"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#" target="_blank">
                      <i className="fa-brands fa-youtube"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#" target="_blank">
                      <i className="fa-brands fa-instagram"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#" target="_blank">
                      <i className="fa-brands fa-facebook"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <i className="fa-brands fa-tiktok"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="#" target="_blank">
                      <i className="fa-brands fa-linkedin-in"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={3} md={6}>
              <div className="links">
                <ul>
                  <li>
                    <Link
                      onClick={() => scrollToSection("categories")}
                      className="nav-link cursor-pointer"
                    >
                      Categories
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => scrollToSection("process")}
                      duration={200}
                      offset={-0}
                      className="nav-link cursor-pointer"
                    >
                      Process
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => scrollToSection("our-mission")}
                      className="nav-link cursor-pointer"
                    >
                      Mission
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => scrollToSection("our-vision")}
                      className="nav-link cursor-pointer"
                    >
                      Vision
                    </Link>
                  </li>
                  {/* <li>
                    <Link to="/blog-list">Pharma News</Link>
                  </li> */}
                </ul>
              </div>
            </Col>
            <Col lg={3} md={6}>
              <div className="links">
                <ul>
                  <li>
                    <Link
                      onClick={() => scrollToSection("testimonial")}
                      className="nav-link cursor-pointer"
                    >
                      Testimonial
                    </Link>
                  </li>

                  <li>
                    <Link
                      onClick={() => scrollToSection("contact")}
                      className="nav-link cursor-pointer"
                    >
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  {/* <li>
                    <Link to="/cookie-policy">Cookie Policy</Link>
                  </li> */}
                  <li onClick={() => navigate("/terms-and-conditions")}>
                    <Link
                    // to="/terms-and-conditions"
                    >
                      Terms and Conditions
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={2} md={6}>
              <div className="try_out">
                <h3>Let’s Try Out</h3>
                <ul className="app_btn">
                  <li>
                    <Link
                      to="https://apps.apple.com/in/app/simbatasker/id6736746247"
                      target="_blank"
                    >
                      <img
                        src={require("../images/ios-down.svg").default}
                        alt="image"
                      />
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://play.google.com/store/apps/details?id=com.simbatasker.app&pcampaignid=web_share"
                      target="_blank"
                    >
                      <img
                        src={require("../images/play-store.svg").default}
                        alt="image"
                      />
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="bottom_footer">
        <Container>
          <Row>
            <Col lg={6}>
              <p>Copyright {currentYear} All rights reserved.</p>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="go_top" onClick={handleArrow}>
        <Link duration={200} offset={-0}>
          {/* <img src={require("../images/go_top.svg").default} alt="image" /> */}
        </Link>
      </div>
    </footer>
  );
}
